import "./CallOutWithImageBlock.scss";
import {
  CallOutTextColumnBlock,
  GridPresetOneHalf,
  GridRow,
  HideFor,
  InfoSmallIcon,
  OptimizelyEditProperty,
  Picture,
} from "/App.Components";
import { CallOutWithImageBlockProps } from "/Models/Generated/CallOutWithImageBlockProps";
import cn from "classnames";
import { NoradTheme } from "/Models/Generated/NoradTheme";
import { RowSpacing } from "/Components/Layout/GridRow/GridRow";

const CallOutWithImageBlock = (props: CallOutWithImageBlockProps) => {
  const { image } = props;
  return (
    <GridRow>
      <div
        className={cn("call-out-with-image-block-norad", {
          "call-out-with-image-block-norad--primary":
            props?.theme === NoradTheme.Primary,
          "call-out-with-image-block-norad--secondary":
            props?.theme === NoradTheme.Secondary,
        })}
      >
        <GridRow rowSpacing={RowSpacing.xs}>
          <GridPresetOneHalf>
            <CallOutTextColumnBlock {...props} />
          </GridPresetOneHalf>
          {(props?.image || props?.imagePropertyName) && (
            <GridPresetOneHalf>
              <OptimizelyEditProperty propertyName={props?.imagePropertyName}>
                <Picture {...props.image} pictureBehaviour="FullWidth" />
              </OptimizelyEditProperty>
              {(!!image?.imageText || !!image?.copyright) && (
                <div className="call-out-with-image-block-norad__copyright">
                  {!!image?.copyright && (
                    <>
                      <HideFor mobile tablet>
                        <InfoSmallIcon
                          text={`${image?.copyrightLabel ?? ""} ${
                            image.copyright
                          }`}
                        />
                      </HideFor>
                      <HideFor desktop desktopMedium desktopLargeUp>
                        <InfoSmallIcon
                          text={`${image?.copyrightLabel ?? ""} ${
                            image.copyright
                          }`}
                        />
                      </HideFor>
                    </>
                  )}
                </div>
              )}
            </GridPresetOneHalf>
          )}
        </GridRow>
      </div>
    </GridRow>
  );
};

export default CallOutWithImageBlock;
